import { Controller } from 'stimulus'
import $ from 'jquery'

/**
 * サイドメニュー
 */
export default class extends Controller {
  connect() {
    $(function () {
      // モーダルオープン
      $('.js-side-menu-open').on('click', function () {
        $('.p-account-config__side').fadeIn(400).addClass('is-open')
      })
      $('.js-side-menu-close').on('click', function () {
        $('.p-account-config__side').fadeOut(400).removeClass('is-open')
      })
      $(window).on('load resize', function () {
        let winW = $(window).width()
        let devW = 999
        if (winW <= devW) return

        $('.p-account-config__side').removeAttr('style')
      })
    })
  }
}
